// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"7207f22a","368":"89eecf9b","434":"58db6fde","478":"225706c7","592":"7bfe24aa","941":"aed13462"}[chunkId] + ".chunk.js";
};